import { TFunction } from 'i18next';
import {
  ContentTypeAPI,
  RemoteAccessProfile,
} from '@mss/mss-component-library';

export const perm = (t: TFunction) => [
  {
    label: t('Authorization'),
    columns: [
      {
        label: t('View'),
        column_permissions: [
          'view_user',
          'view_userpermission',
          'view_userobjectpermission',
          'view_group',
          'view_grouppermission',
          'view_groupobjectpermission',
        ],
      },
      {
        label: t('Create'),
        column_permissions: ['add_user', 'add_group', 'add_usergroup'],
      },
      {
        label: t('Update'),
        column_permissions: [
          'change_user',
          'change_userpermission',
          'change_userobjectpermission',
          'change_group',
          'change_grouppermission',
          'change_groupobjectpermission',
        ],
      },
      {
        label: t('Delete'),
        column_permissions: ['delete_user', 'delete_group', 'delete_usergroup'],
      },
    ],
    permissions: [
      {
        label: t('Users'),
        options: [
          {
            codename: 'view_user',
            license_codename: 'core',
          },
          {
            codename: 'add_user',
            view: 'view_user',
            license_codename: 'core',
          },
          {
            codename: 'change_user',
            view: 'view_user',
            license_codename: 'core',
          },
          {
            codename: 'delete_user',
            view: 'view_user',
            license_codename: 'core',
          },
        ],
      },

      {
        label: t('Global user permissions'),
        options: [
          {
            codename: 'view_userpermission',
            view: 'view_user',
            license_codename: 'core',
          },
          {},
          {
            codename: 'change_userpermission',
            view: 'view_userpermission',
            license_codename: 'core',
          },
          {},
        ],
      },
      {
        label: t('Object user permissions'),
        options: [
          {
            codename: 'view_userobjectpermission',
            view: 'view_user',
            license_codename: 'core',
          },
          {},
          {
            codename: 'change_userobjectpermission',
            view: 'view_userobjectpermission',
            license_codename: 'core',
          },
          {},
        ],
      },
      {
        label: t('Groups'),
        options: [
          {
            codename: 'view_group',
            license_codename: 'core',
          },
          {
            codename: 'add_group',
            view: 'view_group',
            license_codename: 'core',
          },
          {
            codename: 'change_group',
            view: 'view_group',
            license_codename: 'core',
          },
          {
            codename: 'delete_group',
            view: 'view_group',
            license_codename: 'core',
          },
        ],
      },
      {
        label: t('Global group permissions'),
        options: [
          {
            codename: 'view_grouppermission',
            view: 'view_group',
            license_codename: 'core',
          },
          {},
          {
            codename: 'change_grouppermission',
            view: 'view_grouppermission',
            license_codename: 'core',
          },
          {},
        ],
      },
      {
        label: t('Object group permissions'),
        options: [
          {
            codename: 'view_groupobjectpermission',
            view: 'view_group',
            license_codename: 'core',
          },
          {},
          {
            codename: 'change_groupobjectpermission',
            view: 'view_groupobjectpermission',
            license_codename: 'core',
          },
          {},
        ],
      },
      {
        label: t('User-group relations'),
        options: [
          {},
          {
            codename: 'add_usergroup',
            license_codename: 'core',
          },
          {},
          {
            codename: 'delete_usergroup',
            license_codename: 'core',
          },
        ],
      },
    ],
  },
  {
    label: t('Applications'),
    columns: [
      {
        label: t('View site'),
        column_permissions: [
          'view_securityapplicationtrellixepo',
          'view_securityapplicationwsus',
          'view_securityapplicationveeam',
          'view_securityapplicationclaroty',
          'view_securityapplicationnozomi',
          'view_securityapplicationwhatsupgold',
          'view_assetmanagementapplicationprm',
          'view_assetmanagementapplicationisae',
          'view_controlapplicationcentumvp',
          'view_analyzermanagementapplicationaaims',
          'view_analyzermanagementapplicationcalsys',
          'view_virtualizationapplicationmicrosofthyperv',
        ],
      },
      {
        label: t('View center'),
        column_permissions: [
          'view_center_securityapplicationtrellixepo',
          'view_center_securityapplicationwsus',
          'view_center_securityapplicationveeam',
          'view_center_securityapplicationclaroty',
          'view_center_securityapplicationnozomi',
          'view_center_securityapplicationwhatsupgold',
          'view_center_assetmanagementapplicationprm',
          'view_center_assetmanagementapplicationisae',
          'view_center_controlapplicationcentumvp',
          'view_center_analyzermanagementapplicationaaims',
          'view_center_analyzermanagementapplicationcalsys',
          'view_center_virtualizationapplicationmicrosofthyperv',
        ],
      },
      {
        label: t('Create'),
        column_permissions: [
          'add_securityapplicationtrellixepo',
          'add_securityapplicationwsus',
          'add_securityapplicationveeam',
          'add_securityapplicationclaroty',
          'add_securityapplicationnozomi',
          'add_securityapplicationwhatsupgold',
          'add_assetmanagementapplicationprm',
          'add_assetmanagementapplicationisae',
          'add_controlapplicationcentumvp',
          'add_analyzermanagementapplicationaaims',
          'add_analyzermanagementapplicationcalsys',
          'add_virtualizationapplicationmicrosofthyperv',
        ],
      },
      {
        label: t('Update'),
        column_permissions: [
          'change_securityapplicationtrellixepo',
          'change_securityapplicationwsus',
          'change_securityapplicationveeam',
          'change_securityapplicationclaroty',
          'change_securityapplicationnozomi',
          'change_securityapplicationwhatsupgold',
          'change_assetmanagementapplicationprm',
          'change_assetmanagementapplicationisae',
          'change_controlapplicationcentumvp',
          'change_analyzermanagementapplicationaaims',
          'change_analyzermanagementapplicationcalsys',
          'change_virtualizationapplicationmicrosofthyperv',
        ],
      },
      {
        label: t('Delete'),
        column_permissions: [
          'delete_securityapplicationtrellixepo',
          'delete_securityapplicationwsus',
          'delete_securityapplicationveeam',
          'delete_securityapplicationclaroty',
          'delete_securityapplicationnozomi',
          'delete_securityapplicationwhatsupgold',
          'delete_assetmanagementapplicationprm',
          'delete_assetmanagementapplicationisae',
          'delete_controlapplicationcentumvp',
          'delete_analyzermanagementapplicationaaims',
          'delete_analyzermanagementapplicationcalsys',
          'delete_virtualizationapplicationmicrosofthyperv',
        ],
      },
    ],
    permissions: [
      {
        label: t('Security application - Trellix ePO'),
        options: [
          {
            codename: 'view_securityapplicationtrellixepo',
            license_codename: 'securityapplications',
          },
          {
            codename: 'view_center_securityapplicationtrellixepo',
            license_codename: 'securityapplications',
          },
          {
            codename: 'add_securityapplicationtrellixepo',
            view: 'view_securityapplicationtrellixepo',
            license_codename: 'securityapplications',
          },
          {
            codename: 'change_securityapplicationtrellixepo',
            view: 'view_securityapplicationtrellixepo',
            license_codename: 'securityapplications',
          },
          {
            codename: 'delete_securityapplicationtrellixepo',
            view: 'view_securityapplicationtrellixepo',
            license_codename: 'securityapplications',
          },
        ],
      },
      {
        label: t('Security application - WSUS'),
        options: [
          {
            codename: 'view_securityapplicationwsus',
            license_codename: 'securityapplications',
          },
          {
            codename: 'view_center_securityapplicationwsus',
            license_codename: 'securityapplications',
          },
          {
            codename: 'add_securityapplicationwsus',
            view: 'view_securityapplicationwsus',
            license_codename: 'securityapplications',
          },
          {
            codename: 'change_securityapplicationwsus',
            view: 'view_securityapplicationwsus',
            license_codename: 'securityapplications',
          },
          {
            codename: 'delete_securityapplicationwsus',
            view: 'view_securityapplicationwsus',
            license_codename: 'securityapplications',
          },
        ],
      },
      {
        label: t('Security application - Veeam Backup Enterprise Manager'),
        options: [
          {
            codename: 'view_securityapplicationveeam',
            license_codename: 'securityapplications',
          },
          {
            codename: 'view_center_securityapplicationveeam',
            license_codename: 'securityapplications',
          },
          {
            codename: 'add_securityapplicationveeam',
            view: 'view_securityapplicationveeam',
            license_codename: 'securityapplications',
          },
          {
            codename: 'change_securityapplicationveeam',
            view: 'view_securityapplicationveeam',
            license_codename: 'securityapplications',
          },
          {
            codename: 'delete_securityapplicationveeam',
            view: 'view_securityapplicationveeam',
            license_codename: 'securityapplications',
          },
        ],
      },
      {
        label: t('Security application - Claroty'),
        options: [
          {
            codename: 'view_securityapplicationclaroty',
            license_codename: 'securityapplications',
          },
          {
            codename: 'view_center_securityapplicationclaroty',
            license_codename: 'securityapplications',
          },
          {
            codename: 'add_securityapplicationclaroty',
            view: 'view_securityapplicationclaroty',
            license_codename: 'securityapplications',
          },
          {
            codename: 'change_securityapplicationclaroty',
            view: 'view_securityapplicationclaroty',
            license_codename: 'securityapplications',
          },
          {
            codename: 'delete_securityapplicationclaroty',
            view: 'view_securityapplicationclaroty',
            license_codename: 'securityapplications',
          },
        ],
      },
      {
        label: t('Security application - Nozomi'),
        options: [
          {
            codename: 'view_securityapplicationnozomi',
            license_codename: 'securityapplications',
          },
          {
            codename: 'view_center_securityapplicationnozomi',
            license_codename: 'securityapplications',
          },
          {
            codename: 'add_securityapplicationnozomi',
            view: 'view_securityapplicationnozomi',
            license_codename: 'securityapplications',
          },
          {
            codename: 'change_securityapplicationnozomi',
            view: 'view_securityapplicationnozomi',
            license_codename: 'securityapplications',
          },
          {
            codename: 'delete_securityapplicationnozomi',
            view: 'view_securityapplicationnozomi',
            license_codename: 'securityapplications',
          },
        ],
      },
      {
        label: t('Security application - WhatsUp Gold'),
        options: [
          {
            codename: 'view_securityapplicationwhatsupgold',
            license_codename: 'securityapplications',
          },
          {
            codename: 'view_center_securityapplicationwhatsupgold',
            license_codename: 'securityapplications',
          },
          {
            codename: 'add_securityapplicationwhatsupgold',
            view: 'view_securityapplicationwhatsupgold',
            license_codename: 'securityapplications',
          },
          {
            codename: 'change_securityapplicationwhatsupgold',
            view: 'view_securityapplicationwhatsupgold',
            license_codename: 'securityapplications',
          },
          {
            codename: 'delete_securityapplicationwhatsupgold',
            view: 'view_securityapplicationwhatsupgold',
            license_codename: 'securityapplications',
          },
        ],
      },
      {
        label: t('Asset Management Application - PRM'),
        options: [
          {
            codename: 'view_assetmanagementapplicationprm',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'view_center_assetmanagementapplicationprm',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'add_assetmanagementapplicationprm',
            view: 'view_assetmanagementapplicationprm',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'change_assetmanagementapplicationprm',
            view: 'view_assetmanagementapplicationprm',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'delete_assetmanagementapplicationprm',
            view: 'view_assetmanagementapplicationprm',
            license_codename: 'fieldassetsprm',
          },
        ],
      },
      {
        label: t('Asset Management Application - ISAE'),
        options: [
          {
            codename: 'view_assetmanagementapplicationisae',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'view_center_assetmanagementapplicationisae',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'add_assetmanagementapplicationisae',
            view: 'view_assetmanagementapplicationisae',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'change_assetmanagementapplicationisae',
            view: 'view_assetmanagementapplicationisae',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'delete_assetmanagementapplicationisae',
            view: 'view_assetmanagementapplicationisae',
            license_codename: 'fieldassetsprm',
          },
        ],
      },
      {
        label: t('Control applications - Centum VP'),
        options: [
          {
            codename: 'view_controlapplicationcentumvp',
            license_codename: 'controlapplications',
          },
          {
            codename: 'view_center_controlapplicationcentumvp',
            license_codename: 'controlapplications',
          },
          {
            codename: 'add_controlapplicationcentumvp',
            view: 'view_controlapplicationcentumvp',
            license_codename: 'controlapplications',
          },
          {
            codename: 'change_controlapplicationcentumvp',
            view: 'view_controlapplicationcentumvp',
            license_codename: 'controlapplications',
          },
          {
            codename: 'delete_controlapplicationcentumvp',
            view: 'view_controlapplicationcentumvp',
            license_codename: 'controlapplications',
          },
        ],
      },
      {
        label: t('Analyzer Management Application - AAIMS'),
        options: [
          {
            codename: 'view_analyzermanagementapplicationaaims',
            license_codename: 'analyzermanagementapplications',
          },
          {
            codename: 'view_center_analyzermanagementapplicationaaims',
            license_codename: 'analyzermanagementapplications',
          },
          {
            codename: 'add_analyzermanagementapplicationaaims',
            view: 'view_analyzermanagementapplicationaaims',
            license_codename: 'analyzermanagementapplications',
          },
          {
            codename: 'change_analyzermanagementapplicationaaims',
            view: 'view_analyzermanagementapplicationaaims',
            license_codename: 'analyzermanagementapplications',
          },
          {
            codename: 'delete_analyzermanagementapplicationaaims',
            view: 'view_analyzermanagementapplicationaaims',
            license_codename: 'analyzermanagementapplications',
          },
        ],
      },
      {
        label: t('Analyzer Management Application - Calsys'),
        options: [
          {
            codename: 'view_analyzermanagementapplicationcalsys',
            license_codename: 'analyzermanagementapplications',
          },
          {
            codename: 'view_center_analyzermanagementapplicationcalsys',
            license_codename: 'analyzermanagementapplications',
          },
          {
            codename: 'add_analyzermanagementapplicationcalsys',
            view: 'view_analyzermanagementapplicationcalsys',
            license_codename: 'analyzermanagementapplications',
          },
          {
            codename: 'change_analyzermanagementapplicationcalsys',
            view: 'view_analyzermanagementapplicationcalsys',
            license_codename: 'analyzermanagementapplications',
          },
          {
            codename: 'delete_analyzermanagementapplicationcalsys',
            view: 'view_analyzermanagementapplicationcalsys',
            license_codename: 'analyzermanagementapplications',
          },
        ],
      },
      {
        label: t('Virtualization Application - Microsoft Hyper-V'),
        options: [
          {
            codename: 'view_virtualizationapplicationmicrosofthyperv',
            license_codename: 'virtualizationapplications',
          },
          {
            codename: 'view_center_virtualizationapplicationmicrosofthyperv',
            license_codename: 'virtualizationapplications',
          },
          {
            codename: 'add_virtualizationapplicationmicrosofthyperv',
            view: 'view_virtualizationapplicationmicrosofthyperv',
            license_codename: 'virtualizationapplications',
          },
          {
            codename: 'change_virtualizationapplicationmicrosofthyperv',
            view: 'view_virtualizationapplicationmicrosofthyperv',
            license_codename: 'virtualizationapplications',
          },
          {
            codename: 'delete_virtualizationapplicationmicrosofthyperv',
            view: 'view_virtualizationapplicationmicrosofthyperv',
            license_codename: 'virtualizationapplications',
          },
        ],
      },
    ],
  },
  {
    label: t('Assets'),
    columns: [
      {
        label: t('View site'),
        column_permissions: [
          'view_computeassetwindowsagentless',
          'view_fieldassetprm',
          'view_dcsplcassetfcs',
          'view_dcsplcassetscs',
          'view_dcsplcassetavr',
          'view_dcsplcassetbcv',
          'view_dcsplcassetwac',
          'view_dcsplcassetfcn',
          'view_dcsplcassethmistn',
          'view_dcsplcassetsiemensgeneric',
          'view_dcsplcassetsiemenss7',
          'view_networkassetswitch',
          'view_networkassetrouter',
          'view_networkassetfirewall',
          'view_networkassettimeserver',
          'view_envassetodu',
        ],
      },
      {
        label: t('View center'),
        column_permissions: [
          'view_center_computeassetwindowsagentless',
          'view_center_fieldassetprm',
          'view_center_dcsplcassetfcs',
          'view_center_dcsplcassetscs',
          'view_center_dcsplcassetavr',
          'view_center_dcsplcassetbcv',
          'view_center_dcsplcassetwac',
          'view_center_dcsplcassetfcn',
          'view_center_dcsplcassethmistn',
          'view_center_dcsplcassetsiemensgeneric',
          'view_center_dcsplcassetsiemenss7',
          'view_center_networkassetswitch',
          'view_center_networkassetrouter',
          'view_center_networkassetfirewall',
          'view_center_networkassettimeserver',
          'view_center_envassetodu',
        ],
      },
      {
        label: t('Create'),
        column_permissions: [
          'add_computeassetwindowsagentless',
          'add_fieldassetprm',
          'add_dcsplcassetfcs',
          'add_dcsplcassetscs',
          'add_dcsplcassetavr',
          'add_dcsplcassetbcv',
          'add_dcsplcassetwac',
          'add_dcsplcassetfcn',
          'add_dcsplcassethmistn',
          'add_dcsplcassetsiemensgeneric',
          'add_dcsplcassetsiemenss7',
          'add_networkassetswitch',
          'add_networkassetrouter',
          'add_networkassetfirewall',
          'add_networkassettimeserver',
          'add_envassetodu',
        ],
      },
      {
        label: t('Update'),
        column_permissions: [
          'change_computeassetwindowsagentless',
          'change_fieldassetprm',
          'change_dcsplcassetfcs',
          'change_dcsplcassetscs',
          'change_dcsplcassetavr',
          'change_dcsplcassetbcv',
          'change_dcsplcassetwac',
          'change_dcsplcassetfcn',
          'change_dcsplcassethmistn',
          'change_dcsplcassetsiemensgeneric',
          'change_dcsplcassetsiemenss7',
          'change_networkassetswitch',
          'change_networkassetrouter',
          'change_networkassetfirewall',
          'change_networkassettimeserver',
          'change_envassetodu',
        ],
      },
      {
        label: t('Delete'),
        column_permissions: [
          'delete_computeassetwindowsagentless',
          'delete_fieldassetprm',
          'delete_dcsplcassetfcs',
          'delete_dcsplcassetscs',
          'delete_dcsplcassetavr',
          'delete_dcsplcassetbcv',
          'delete_dcsplcassetwac',
          'delete_dcsplcassetfcn',
          'delete_dcsplcassethmistn',
          'delete_dcsplcassetsiemensgeneric',
          'delete_dcsplcassetsiemenss7',
          'delete_networkassetswitch',
          'delete_networkassetrouter',
          'delete_networkassetfirewall',
          'delete_networkassettimeserver',
          'delete_envassetodu',
        ],
      },
    ],
    permissions: [
      {
        label: t('Compute Assets - Windows Agentless'),
        options: [
          {
            codename: 'view_computeassetwindowsagentless',
            license_codename: 'computeassets',
          },
          {
            codename: 'view_center_computeassetwindowsagentless',
            license_codename: 'computeassets',
          },
          {
            codename: 'add_computeassetwindowsagentless',
            view: 'view_computeassetwindowsagentless',
            license_codename: 'computeassets',
          },
          {
            codename: 'change_computeassetwindowsagentless',
            view: 'view_computeassetwindowsagentless',
            license_codename: 'computeassets',
          },
          {
            codename: 'delete_computeassetwindowsagentless',
            view: 'view_computeassetwindowsagentless',
            license_codename: 'computeassets',
          },
        ],
      },
      {
        label: t('Field Assets - PRM'),
        options: [
          {
            codename: 'view_fieldassetprm',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'view_center_fieldassetprm',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'add_fieldassetprm',
            view: 'view_fieldassetprm',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'change_fieldassetprm',
            view: 'view_fieldassetprm',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'delete_fieldassetprm',
            view: 'view_fieldassetprm',
            license_codename: 'fieldassetsprm',
          },
        ],
      },
      {
        label: t('PLC/DCS Assets - FCS'),
        options: [
          {
            codename: 'view_dcsplcassetfcs',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'view_center_dcsplcassetfcs',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'add_dcsplcassetfcs',
            view: 'view_dcsplcassetfcs',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'change_dcsplcassetfcs',
            view: 'view_dcsplcassetfcs',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'delete_dcsplcassetfcs',
            view: 'view_dcsplcassetfcs',
            license_codename: 'plcdcsassets',
          },
        ],
      },
      {
        label: t('PLC/DCS Assets - SCS'),
        options: [
          {
            codename: 'view_dcsplcassetscs',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'view_center_dcsplcassetscs',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'add_dcsplcassetscs',
            view: 'view_dcsplcassetscs',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'change_dcsplcassetscs',
            view: 'view_dcsplcassetscs',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'delete_dcsplcassetscs',
            view: 'view_dcsplcassetscs',
            license_codename: 'plcdcsassets',
          },
        ],
      },
      {
        label: t('PLC/DCS Assets - AVR'),
        options: [
          {
            codename: 'view_dcsplcassetavr',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'view_center_dcsplcassetavr',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'add_dcsplcassetavr',
            view: 'view_dcsplcassetavr',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'change_dcsplcassetavr',
            view: 'view_dcsplcassetavr',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'delete_dcsplcassetavr',
            view: 'view_dcsplcassetavr',
            license_codename: 'plcdcsassets',
          },
        ],
      },
      {
        label: t('PLC/DCS Assets - BCV'),
        options: [
          {
            codename: 'view_dcsplcassetbcv',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'view_center_dcsplcassetbcv',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'add_dcsplcassetbcv',
            view: 'view_dcsplcassetbcv',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'change_dcsplcassetbcv',
            view: 'view_dcsplcassetbcv',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'delete_dcsplcassetbcv',
            view: 'view_dcsplcassetbcv',
            license_codename: 'plcdcsassets',
          },
        ],
      },
      {
        label: t('PLC/DCS Assets - WAC'),
        options: [
          {
            codename: 'view_dcsplcassetwac',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'view_center_dcsplcassetwac',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'add_dcsplcassetwac',
            view: 'view_dcsplcassetwac',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'change_dcsplcassetwac',
            view: 'view_dcsplcassetwac',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'delete_dcsplcassetwac',
            view: 'view_dcsplcassetwac',
            license_codename: 'plcdcsassets',
          },
        ],
      },
      {
        label: t('PLC/DCS Assets - FCN'),
        options: [
          {
            codename: 'view_dcsplcassetfcn',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'view_center_dcsplcassetfcn',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'add_dcsplcassetfcn',
            view: 'view_dcsplcassetfcn',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'change_dcsplcassetfcn',
            view: 'view_dcsplcassetfcn',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'delete_dcsplcassetfcn',
            view: 'view_dcsplcassetfcn',
            license_codename: 'plcdcsassets',
          },
        ],
      },
      {
        label: t('PLC/DCS Assets - HMI/STN'),
        options: [
          {
            codename: 'view_dcsplcassethmistn',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'view_center_dcsplcassethmistn',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'add_dcsplcassethmistn',
            view: 'view_dcsplcassethmistn',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'change_dcsplcassethmistn',
            view: 'view_dcsplcassethmistn',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'delete_dcsplcassethmistn',
            view: 'view_dcsplcassethmistn',
            license_codename: 'plcdcsassets',
          },
        ],
      },
      {
        label: t('PLC/DCS Assets - Siemens Generic'),
        options: [
          {
            codename: 'view_dcsplcassetsiemensgeneric',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'view_center_dcsplcassetsiemensgeneric',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'add_dcsplcassetsiemensgeneric',
            view: 'view_dcsplcassetsiemensgeneric',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'change_dcsplcassetsiemensgeneric',
            view: 'view_dcsplcassetsiemensgeneric',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'delete_dcsplcassetsiemensgeneric',
            view: 'view_dcsplcassetsiemensgeneric',
            license_codename: 'plcdcsassets',
          },
        ],
      },
      {
        label: t('PLC/DCS Assets - Siemens S7'),
        options: [
          {
            codename: 'view_dcsplcassetsiemenss7',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'view_center_dcsplcassetsiemenss7',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'add_dcsplcassetsiemenss7',
            view: 'view_dcsplcassetsiemenss7',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'change_dcsplcassetsiemenss7',
            view: 'view_dcsplcassetsiemenss7',
            license_codename: 'plcdcsassets',
          },
          {
            codename: 'delete_dcsplcassetsiemenss7',
            view: 'view_dcsplcassetsiemenss7',
            license_codename: 'plcdcsassets',
          },
        ],
      },
      {
        label: t('Network Assets - Switch'),
        options: [
          {
            codename: 'view_networkassetswitch',
            license_codename: 'networkassets',
          },
          {
            codename: 'view_center_networkassetswitch',
            license_codename: 'networkassets',
          },
          {
            codename: 'add_networkassetswitch',
            view: 'view_networkassetswitch',
            license_codename: 'networkassets',
          },
          {
            codename: 'change_networkassetswitch',
            view: 'view_networkassetswitch',
            license_codename: 'networkassets',
          },
          {
            codename: 'delete_networkassetswitch',
            view: 'view_networkassetswitch',
            license_codename: 'networkassets',
          },
        ],
      },

      {
        label: t('Network Assets - Router'),
        options: [
          {
            codename: 'view_networkassetrouter',
            license_codename: 'networkassets',
          },
          {
            codename: 'view_center_networkassetrouter',
            license_codename: 'networkassets',
          },
          {
            codename: 'add_networkassetrouter',
            view: 'view_networkassetrouter',
            license_codename: 'networkassets',
          },
          {
            codename: 'change_networkassetrouter',
            view: 'view_networkassetrouter',
            license_codename: 'networkassets',
          },
          {
            codename: 'delete_networkassetrouter',
            view: 'view_networkassetrouter',
            license_codename: 'networkassets',
          },
        ],
      },
      {
        label: t('Network Assets - Firewall'),
        options: [
          {
            codename: 'view_networkassetfirewall',
            license_codename: 'networkassets',
          },
          {
            codename: 'view_center_networkassetfirewall',
            license_codename: 'networkassets',
          },
          {
            codename: 'add_networkassetfirewall',
            view: 'view_networkassetfirewall',
            license_codename: 'networkassets',
          },
          {
            codename: 'change_networkassetfirewall',
            view: 'view_networkassetfirewall',
            license_codename: 'networkassets',
          },
          {
            codename: 'delete_networkassetfirewall',
            view: 'view_networkassetfirewall',
            license_codename: 'networkassets',
          },
        ],
      },

      {
        label: t('Network Assets - Timeserver'),
        options: [
          {
            codename: 'view_networkassettimeserver',
            license_codename: 'networkassets',
          },
          {
            codename: 'view_center_networkassettimeserver',
            license_codename: 'networkassets',
          },
          {
            codename: 'add_networkassettimeserver',
            view: 'view_networkassettimeserver',
            license_codename: 'networkassets',
          },
          {
            codename: 'change_networkassettimeserver',
            view: 'view_networkassettimeserver',
            license_codename: 'networkassets',
          },
          {
            codename: 'delete_networkassettimeserver',
            view: 'view_networkassettimeserver',
            license_codename: 'networkassets',
          },
        ],
      },

      {
        label: t('Environmental Assets - ODU'),
        options: [
          {
            codename: 'view_envassetodu',
            license_codename: 'environmentalassets',
          },
          {
            codename: 'view_center_envassetodu',
            license_codename: 'environmentalassets',
          },
          {
            codename: 'add_envassetodu',
            view: 'view_envassetodu',
            license_codename: 'environmentalassets',
          },
          {
            codename: 'change_envassetodu',
            view: 'view_envassetodu',
            license_codename: 'environmentalassets',
          },
          {
            codename: 'delete_envassetodu',
            view: 'view_envassetodu',
            license_codename: 'environmentalassets',
          },
        ],
      },
    ],
  },
  {
    label: t('Discovery'),
    columns: [
      {
        label: t('View'),
        column_permissions: ['view_assetdiscovery', 'view_fieldassetdiscovery'],
      },
      {
        label: t('Start/Add'),
        column_permissions: ['add_assetdiscovery', 'add_fieldassetdiscovery'],
      },
      {
        label: t('Change'),
        column_permissions: [
          'change_assetdiscovery',
          'change_fieldassetdiscovery',
        ],
      },
      {
        label: t('Delete'),
        column_permissions: [
          'delete_assetdiscovery',
          'delete_fieldassetdiscovery',
        ],
      },
    ],
    permissions: [
      {
        label: t('Asset Discovery'),
        options: [
          {
            codename: 'view_assetdiscovery',
            license_codename: 'computeassets',
          },
          {
            codename: 'add_assetdiscovery',
            view: 'view_assetdiscovery',
            license_codename: 'computeassets',
          },
          {
            codename: 'change_assetdiscovery',
            view: 'view_assetdiscovery',
            license_codename: 'computeassets',
          },
          {
            codename: 'delete_assetdiscovery',
            view: 'view_assetdiscovery',
            license_codename: 'computeassets',
          },
        ],
      },

      {
        label: t('Field Asset Discovery'),
        options: [
          {
            codename: 'view_fieldassetdiscovery',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'add_fieldassetdiscovery',
            view: 'view_fieldassetdiscovery',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'change_fieldassetdiscovery',
            view: 'view_fieldassetdiscovery',
            license_codename: 'fieldassetsprm',
          },
          {
            codename: 'delete_fieldassetdiscovery',
            view: 'view_fieldassetdiscovery',
            license_codename: 'fieldassetsprm',
          },
        ],
      },
    ],
  },
  {
    label: t('Network Assets'),
    columns: [
      {
        label: t('View Site'),
      },
      {
        label: t('View Center'),
      },
      {
        label: t('Update Collectors'),
      },
    ],
    permissions: [
      {
        label: t('Network Configuration'),
        options: [
          {
            codename: 'view_networkconfig',
            license_codename: 'networkassets',
          },
          {
            codename: 'view_center_networkconfig',
            license_codename: 'networkassets',
          },
          {
            codename: 'change_networkconfig',
            view: 'view_networkconfig',
            license_codename: 'networkassets',
          },
        ],
      },
    ],
  },
  {
    label: t('Remote Access - Connections'),
    columns: [
      {
        label: t('Request access center'),
        column_permissions: [
          'create_rdp_remoterequest_center',
          'create_ssh_remoterequest_center',
          'create_vnc_remoterequest_center',
          'create_web_remoterequest_center',
        ],
      },
      {
        label: t('Request access site'),
        column_permissions: [
          'create_rdp_remoterequest',
          'create_ssh_remoterequest',
          'create_vnc_remoterequest',
          'create_web_remoterequest',
        ],
      },
      {
        label: t('Direct access center'),
        column_permissions: [
          'start_rdp_remotesession_center',
          'start_ssh_remotesession_center',
          'start_vnc_remotesession_center',
          'start_web_remotesession_center',
        ],
      },
      {
        label: t('Direct access site'),
        column_permissions: [
          'start_rdp_remotesession',
          'start_ssh_remotesession',
          'start_vnc_remotesession',
          'start_web_remotesession',
        ],
      },
    ],
    permissions: [
      {
        label: t('RDP'),
        options: [
          {
            codename: 'create_rdp_remoterequest_center',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'create_rdp_remoterequest',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'start_rdp_remotesession_center',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'start_rdp_remotesession',
            license_codename: 'remoteaccessconnect',
          },
        ],
      },
      {
        label: t('SSH'),
        options: [
          {
            codename: 'create_ssh_remoterequest_center',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'create_ssh_remoterequest',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'start_ssh_remotesession_center',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'start_ssh_remotesession',
            license_codename: 'remoteaccessconnect',
          },
        ],
      },
      {
        label: t('VNC'),
        options: [
          {
            codename: 'create_vnc_remoterequest_center',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'create_vnc_remoterequest',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'start_vnc_remotesession_center',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'start_vnc_remotesession',
            license_codename: 'remoteaccessconnect',
          },
        ],
      },
      {
        label: t('WEB'),
        options: [
          {
            codename: 'create_web_remoterequest_center',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'create_web_remoterequest',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'start_web_remotesession_center',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'start_web_remotesession',
            license_codename: 'remoteaccessconnect',
          },
        ],
      },
    ],
  },

  {
    label: t('Remote Access - Management'),
    columns: [
      {
        label: t('Download'),
      },
      {
        label: t('View'),
        column_permissions: [
          'admin_view_remoterequest',
          'admin_view_remotesession',
          'observer_remotesession',
          'view_recording_remotesession',
        ],
      },
      {
        label: t('Update'),
        column_permissions: [
          'admin_update_remoterequest',
          'admin_update_remotesession',
        ],
      },
    ],
    permissions: [
      {
        label: t('Requests'),
        options: [
          {},
          {
            codename: 'admin_view_remoterequest',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'admin_update_remoterequest',
            view: 'admin_view_remoterequest',
            license_codename: 'remoteaccessconnect',
          },
        ],
      },
      {
        label: t('Sessions'),
        options: [
          {},
          {
            codename: 'admin_view_remotesession',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'admin_update_remotesession',
            view: 'admin_view_remotesession',
            license_codename: 'remoteaccessconnect',
          },
        ],
      },
      {
        label: t('Session live view'),
        options: [
          {},
          {
            codename: 'observer_remotesession',
            view: 'admin_view_remotesession',
            license_codename: 'remoteaccessconnect',
          },
          {},
        ],
      },
      {
        label: t('Session Recordings'),
        options: [
          {
            codename: 'download_recordingexport',
            view: ['view_recording_remotesession', 'admin_view_remotesession'],
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'view_recording_remotesession',
            view: 'admin_view_remotesession',
            license_codename: 'remoteaccessconnect',
          },
          {},
        ],
      },
    ],
  },
  {
    label: t('Remote Access - Profile'),
    columns: [
      { label: t('View') },
      { label: t('Create') },
      { label: t('Update') },
      { label: t('Delete') },
    ],
    permissions: [
      {
        label: t('Remote profile'),
        options: [
          {
            codename: 'view_remoteprofile',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'add_remoteprofile',
            view: 'view_remoteprofile',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'change_remoteprofile',
            view: 'view_remoteprofile',
            license_codename: 'remoteaccessconnect',
          },
          {
            codename: 'delete_remoteprofile',
            view: 'view_remoteprofile',
            license_codename: 'remoteaccessconnect',
          },
        ],
      },
    ],
  },

  {
    label: t('File Transfers'),
    columns: [
      { label: t('Upload center') },
      { label: t('Upload site') },
      { label: t('Download center') },
      { label: t('Download site') },
      { label: t('Share files') },
      { label: t('Set expiration') },
    ],
    permissions: [
      {
        label: t('Manual file transfer'),
        options: [
          {
            codename: 'add_center_filetransfer', //upload center
            license_codename: 'filetransfer',
          },
          {
            codename: 'add_filetransfer', //upload site
            license_codename: 'filetransfer',
          },
          {
            codename: 'view_center_filetransfer', // download center
            license_codename: 'filetransfer',
          },
          {
            codename: 'view_filetransfer', // download site
            license_codename: 'filetransfer',
          },
          {
            codename: 'share_filetransfer', // share files
            license_codename: 'filetransfer',
          },
          {
            codename: 'expire_filetransfer', // set expiration date
            license_codename: 'filetransfer',
          },
        ],
      },
    ],
  },
  {
    label: t('Monitors'),
    columns: [
      {
        label: t('View'),
        column_permissions: [
          'view_automationmonitorasset',
          'view_automationmonitorprofile',
        ],
      },
      {
        label: t('Update'),
        column_permissions: [
          'change_automationmonitorasset',
          'change_automationmonitorprofile',
        ],
      },
    ],
    permissions: [
      {
        label: t('Monitors'),
        options: [
          {
            codename: 'view_automationmonitorasset',
            license_codename: 'automations',
          },
          {
            codename: 'change_automationmonitorasset',
            view: 'view_automationmonitorasset',
            license_codename: 'automations',
          },
        ],
      },
      {
        label: t('Profiles'),
        options: [
          {
            codename: 'view_automationmonitorprofile',
            license_codename: 'automations',
          },
          {
            codename: 'change_automationmonitorprofile',
            view: 'view_automationmonitorprofile',
            license_codename: 'automations',
          },
        ],
      },
    ],
  },
  {
    label: t('Site configuration'),
    columns: [
      {
        label: t('View'),
        column_permissions: [
          'view_configuration_site',
          'view_automation',
          'view_customfield',
          'view_servicenowconfig',
          'view_opcservergroupconfig',
        ],
      },
      {
        label: t('Create'),
        column_permissions: [
          'add_automation',
          'add_customfield',
          'add_servicenowconfig',
          'add_opcservergroupconfig',
        ],
      },
      {
        label: t('Update'),
        column_permissions: [
          'change_automation',
          'change_customfield',
          'change_servicenowconfig',
          'change_opcservergroupconfig',
        ],
      },
      {
        label: t('Delete'),
        column_permissions: [
          'delete_automation',
          'delete_customfield',
          'delete_servicenowconfig',
          'delete_opcservergroupconfig',
        ],
      },
    ],
    permissions: [
      {
        label: t('Configuration'),
        options: [
          {
            codename: 'view_configuration_site',
            license_codename: 'core',
          },
          {},
          {},
          {},
        ],
      },
      {
        label: t('Automations'),
        options: [
          {
            codename: 'view_automation',
            license_codename: 'automations',
          },
          {
            codename: 'add_automation',
            view: 'view_automation',
            license_codename: 'automations',
          },
          {
            codename: 'change_automation',
            view: 'view_automation',
            license_codename: 'automations',
          },
          {
            codename: 'delete_automation',
            view: 'view_automation',
            license_codename: 'automations',
          },
        ],
      },
      {
        label: t('Asset Configuration'),
        options: [
          {
            codename: 'view_customfield',
            license_codename: 'customfields',
          },
          {
            codename: 'add_customfield',
            view: 'view_customfield',
            license_codename: 'customfields',
          },
          {
            codename: 'change_customfield',
            view: 'view_customfield',
            license_codename: 'customfields',
          },
          {
            codename: 'delete_customfield',
            view: 'view_customfield',
            license_codename: 'customfields',
          },
        ],
      },
      {
        label: t('Integration'),
        options: [
          {
            codename: 'view_servicenowconfig',
            license_codename: 'servicenowintegration',
          },
          {
            codename: 'add_servicenowconfig',
            view: 'view_servicenowconfig',
            license_codename: 'servicenowintegration',
          },
          {
            codename: 'change_servicenowconfig',
            view: 'view_servicenowconfig',
            license_codename: 'servicenowintegration',
          },
          {
            codename: 'delete_servicenowconfig',
            view: 'view_servicenowconfig',
            license_codename: 'servicenowintegration',
          },
        ],
      },
      {
        label: t('OPC server groups'),
        options: [
          {
            codename: 'view_opcservergroupconfig',
            license_codename: 'opcconfiguration',
          },
          {
            codename: 'add_opcservergroupconfig',
            view: 'view_opcservergroupconfig',
            license_codename: 'opcconfiguration',
          },
          {
            codename: 'change_opcservergroupconfig',
            view: 'view_opcservergroupconfig',
            license_codename: 'opcconfiguration',
          },
          {
            codename: 'delete_opcservergroupconfig',
            view: 'view_opcservergroupconfig',
            license_codename: 'opcconfiguration',
          },
        ],
      },
    ],
  },
  {
    label: t('Dashboards'),
    columns: [
      { label: t('View') },
      { label: t('Create') },
      { label: t('Update') },
      { label: t('Delete') },
    ],
    permissions: [
      {
        label: t('Dashboards'),
        options: [
          {
            codename: 'view_center_dashboard',
            license_codename: 'dashboards',
          },
          {
            codename: 'add_center_dashboard',
            view: 'view_center_dashboard',
            license_codename: 'dashboards',
          },
          {
            codename: 'change_center_dashboard',
            view: 'view_center_dashboard',
            license_codename: 'dashboards',
          },
          {
            codename: 'delete_center_dashboard',
            view: 'view_center_dashboard',
            license_codename: 'dashboards',
          },
        ],
      },
    ],
  },
  {
    label: t('Alerts'),
    columns: [
      { label: t('View Center') },
      { label: t('Update') },
    ],
    permissions: [
      {
        label: t('Alerts'),
        options: [
          {
            codename: 'view_center_alert',
            license_codename: 'automations',
          },
          {
            codename: 'change_alert',
            view: 'view_center_alert',
            license_codename: 'automations',
          },
        ],
      },
    ],
  },
  {
    label: t('Admin'),
    columns: [
      { label: t('View site') },
      { label: t('Edit site') },
    ],
    permissions: [
      {
        label: t('Activity Log'),
        options: [
          {
            codename: 'view_activitylog',
            license_codename: 'core',
          },
          {},
        ],
      },
      {
        label: t('Worker'),
        options: [
          {
            codename: 'view_worker',
            license_codename: 'core',
          },
          {
            codename: 'change_worker',
            view: 'view_worker',
            license_codename: 'core',
          },
        ],
      },
    ],
  },
];
type AssetContentTypes = {
  [key: string]: ContentTypeAPI | undefined;
};

const assetPerm = (
  t: TFunction,
  contentType: AssetContentTypes,
  userPermissions: any[],
  profiles: Array<RemoteAccessProfile & { id: string }>,
  parentObjectId: string
): PermissionSet[] => {
  const applicationTypes = [
    'securityapplicationwsus',
    'securityapplicationtrellixepo',
    'securityapplicationveeam',
    'assetmanagementapplicationprm',
    'analyzermanagementapplicationaaims',
    'analyzermanagementapplicationcalsys',
    'controlapplicationcentumvp',
    'virtualizationapplicationmicrosofthyperv',
  ];
  const assetType = applicationTypes.includes(contentType.obj?.model || '')
    ? 'Application'
    : 'Asset';
  const permArr: PermissionSet[] = [
    {
      label: t(assetType),
      content_type: contentType.obj?.id,
      columns: [
        t('View site'),
        t('View center'),
        t('Update'),
        t('Delete'),
      ],
      permissions: [
        {
          label: t('General permissions'),
          object_id: parentObjectId,
          options: [
            {
              codename: `view_${contentType.obj?.model}`,
              isInherited:
                userPermissions.findIndex(
                  x => x.codename === `view_${contentType.obj?.model}`
                ) > -1,
            },
            {
              codename: `view_center_${contentType.obj?.model}`,
              isInherited:
                userPermissions.findIndex(x => {
                  return x.codename === `view_center_${contentType.obj?.model}`;
                }) > -1,
            },
            {
              codename: `change_${contentType.obj?.model}`,
              isInherited:
                userPermissions.findIndex(
                  x => x.codename === `change_${contentType.obj?.model}`
                ) > -1,
              view: `view_${contentType.obj?.model}`,
            },
            {
              codename: `delete_${contentType.obj?.model}`,
              isInherited:
                userPermissions.findIndex(
                  x => x.codename === `delete_${contentType.obj?.model}`
                ) > -1,
              view: `view_${contentType.obj?.model}`,
            },
          ],
        },
      ],
    },
  ];

  if (profiles.length > 0)
    permArr.push({
      label: t('Remote Access Profiles'),
      content_type: contentType.profile?.id,
      columns: [
        t('Request access center'),
        t('Request access site'),
        t('Direct access center'),
        t('Direct access site'),
      ],
      permissions: profiles.map(profile => ({
        object_id: profile.id,
        label: `${profile.protocol.toUpperCase()} - ${profile.name}`,
        options: [
          {
            codename: `create_${profile.protocol}_remoterequest_center`,
            isInherited:
              userPermissions.findIndex(
                x =>
                  x.codename ===
                  `create_${profile.protocol}_remoterequest_center`
              ) > -1,
          },
          {
            codename: `create_${profile.protocol}_remoterequest`,
            isInherited:
              userPermissions.findIndex(
                x => x.codename === `create_${profile.protocol}_remoterequest`
              ) > -1,
          },
          {
            codename: `start_${profile.protocol}_remotesession_center`,
            isInherited:
              userPermissions.findIndex(
                x =>
                  x.codename ===
                  `start_${profile.protocol}_remotesession_center`
              ) > -1,
          },
          {
            codename: `start_${profile.protocol}_remotesession`,
            isInherited:
              userPermissions.findIndex(
                x => x.codename === `start_${profile.protocol}_remotesession`
              ) > -1,
          },
        ],
      })),
    });
  return permArr;
};

export const assetPermissions = (
  t: TFunction,
  contentType: AssetContentTypes,
  userPermissions: any[],
  profiles: Array<RemoteAccessProfile & { id: string }>,
  parentObjectId: string
) =>
  createPermissions(
    assetPerm(t, contentType, userPermissions, profiles, parentObjectId)
  );

// Some typecasting, but the root cause should be fixed
export const permissions = (t: TFunction) =>
  createPermissions(perm(t) as PermissionSet[]);

export const createPermissions = (arr: PermissionSet[]) =>
  arr.map(x => ({
    ...x,
    permissions: x.permissions.map((y: PermissionSetRow) => ({
      ...y,
      options: y.options.map((z: PermissionSetOption) => ({
        ...z,
        permission_id: undefined,
      })),
    })),
  }));

export type AllPermissionAPI = {
  id: number;
  name: string;
  codename: string;
  content_type: number;
};

export type UserPermissionsAPI = {
  codename: string;
  groups: PermissionSetOptionGroups[];
  permission_id: number | string;
  user_permission_id?: number | null;
  object_id?: number | string;
};

export type PermissionSetOptionGroups = {
  id: number;
  name: string;
};

export type PermissionSetOption = {
  codename?: string;
  isInherited?: boolean;
  groups?: PermissionSetOptionGroups[];
  disabled?: boolean;
  permission_id?: number | string;
  view?: string | string[];
  license_codename?: string; // TODO: Check if just making this optional is preferable
};

export type PermissionSetRow = {
  label: string;
  options: PermissionSetOption[];
  object_id?: string;
};

export type PermissionSet = {
  label: string;
  content_type?: number;
  columns: PermissionColumn[];
  permissions: PermissionSetRow[];
};

export type PermissionColumn = {
  label: string;
  column_permissions: string[];
};
